/**
 * FIDS ScoreBadge — the 0–100 opportunity signal.
 * Uses semantic tones: opportunity (≥80), warning (65–79), risk (<65).
 * Numeric direction forced to LTR to avoid RTL-flipping.
 */
export const ScoreBadge = ({ score, size = "md", testId }) => {
  const tier = score >= 80 ? "high" : score >= 65 ? "medium" : "low";

  const tiers = {
    high: "bg-opportunity-50 text-opportunity-700 border-opportunity-100",
    medium: "bg-warning-50 text-warning-700 border-warning-100",
    low: "bg-risk-50 text-risk-700 border-risk-100",
  };

  const dot = {
    high: "bg-opportunity-500",
    medium: "bg-warning-500",
    low: "bg-risk-500",
  };

  const sizes = {
    sm: "px-2 py-0.5 text-[11px]",
    md: "px-2.5 py-1 text-xs",
    lg: "px-3 py-1.5 text-sm",
  };

  return (
    <span
      data-testid={testId}
      dir="ltr"
      className={`inline-flex items-center gap-1.5 rounded-full border font-mono font-semibold tracking-tight ${tiers[tier]} ${sizes[size]}`}
      aria-label={`نقاط الفرصة: ${score} من 100`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot[tier]}`} aria-hidden />
      <span>{score}</span>
      <span className="opacity-60">/ 100</span>
    </span>
  );
};
